




import React, { useState } from "react";
import { Country, State, City } from "country-state-city";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

const Form = () => {
  const [form, setForm] = useState({
    listing_level: "Level One", // Default selection
  });
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const BLOOD_GROUPS1 = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
  const BLOOD_GROUPS2 = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
  const REGION_OPTIONS = [
    "Northern Region",
    "Southern Region",
    "Western Region",
    "Eastern Region",
  ];

  const CHAPTER_OPTIONS = [
    "Andhra Pradesh & Telangana Chapter",
    "Central & South Maharashtra Chapter",
    "Chandigarh Chapter",
    "Goa Chapter",
    "Gujarat Chapter",
    "Jammu and Kashmir Chapter",
    "Karnataka Chapter",
    "Kerala Chapter",
    "MP & CG Chapter",
    "Vidarbha Chapter",
    "Punjab Chapter",
    "Rajasthan Chapter",
    "Saurashtra Kutch Chapter",
    "South Gujarat Chapter",
    "South Tamilnadu Chapter",
    "Uttar Pradesh & Uttarakhand Chapter",
  ];

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (name === "year_of_joining" && !/^\d{0,4}$/.test(value)) return;

    if (type === "file") {
      const file = files[0];
      if (!file) return;

      // 1. VALIDATE FILE TYPE (Strictly Image Only)
      if (!file.type.startsWith("image/")) {
        alert("❌ Invalid file type! Please upload an image (JPG, JPEG, or PNG). PDFs and other documents are not allowed.");
        e.target.value = ""; // Clear the input visually
        return;
      }

      // 2. VALIDATE FILE SIZE
      const isPhoto = name === "acc_rep1_photo" || name === "acc_rep2_photo";
      const maxSize = isPhoto ? 1 * 1024 * 1024 : 10 * 1024 * 1024; // 1MB for photos, 10MB for logo/ads

      if (file.size > maxSize) {
        alert(`❌ File too large! Max allowed size for this field is ${isPhoto ? "1MB" : "10MB"}.`);
        e.target.value = ""; // Clear the input visually
        return;
      }

      setForm({ ...form, [name]: file });
    } else if (type === "checkbox") {
      setForm({ ...form, [name]: checked });
    } else {
      let newValue = value;
      if (name === "telephone") newValue = value.replace(/\D/g, "");

      const updatedForm = { ...form, [name]: newValue };

      if (name === "country") {
        const states = State.getStatesOfCountry(newValue);
        setStatesList(states);
        updatedForm.state = "";
        updatedForm.city = "";
        setCitiesList([]);
      }

      if (name === "state") {
        const cities = City.getCitiesOfState(form.country, newValue);
        setCitiesList(cities);
        updatedForm.city = "";
      }

      setForm(updatedForm);
    }
  };


  // const handleSubmit = async () => {
  //   const requiredFields = ["agency_name", "email", "mobile", "declaration_consent"];
  //   const missingFields = requiredFields.filter(
  //     (field) => !form[field] || form[field].toString().trim() === "" || form[field] === false
  //   );

  //   if (missingFields.length > 0) {
  //     alert(`Please fill in all required fields and accept the declaration.`);
  //     return;
  //   }

  //   const formData = new FormData();
  //   for (let key in form) {
  //     if (form[key] !== undefined) formData.append(key, form[key]);
  //   }

  //   try {
  //     const response = await fetch("https://taaiappapi.emedha.in/pages/api/api/agency", {
  //       method: "POST",
  //       body: formData, 
  //     });
  //     if (response.ok) {
  //       alert("✅ Form submitted successfully!");

  //       // 1. Reset the form state to clear inputs without refreshing the page
  //       setForm({
  //         listing_level: "Level One", // Reset to default
  //       });

  //       // 2. Clear lists if necessary
  //       setStatesList([]);
  //       setCitiesList([]);

  //       // Optional: Scroll to top so user sees the empty form
  //       window.scrollTo({ top: 0, behavior: 'smooth' });

  //     } else {
  //       // Try to get error detail, but don't crash if it's not JSON
  //       const errorText = await response.text();
  //       alert(`❌ Submission failed: ${errorText || response.statusText}`);
  //     }
  //   } catch (error) {
  //     console.error("Submission Error:", error);
  //     alert("❌ Network error or server did not respond correctly.");
  //   }
  // };

  const handleSubmit = async () => {
    // All other required fields
    const requiredFields = ["agency_name", "email", "mobile", "declaration_consent"];

    // Check missing fields except region/chapter
    const missingFields = requiredFields.filter((field) => {
      if (field === "declaration_consent") {
        return form[field] !== true;
      }
      return !form[field]?.toString().trim();
    });

    // Check at least one of region or chapter
    if (!form.region?.trim() && !form.chapter?.trim()) {
      missingFields.push("region/chapter");
    }

    if (missingFields.length > 0) {
      alert(
        `Please fill in all required fields: ${missingFields.join(", ")}`
      );
      return;
    }

    // Prepare FormData
    const formData = new FormData();
    for (let key in form) {
      if (form[key] !== undefined && form[key] !== null) {
        formData.append(key, form[key]);
      }
    }

    try {
      const response = await fetch(
        "https://taaiappapi.emedha.in/pages/api/api/agency",
        {
          method: "POST",
          body: formData,
        }
      );

      let result = {};
      try {
        result = await response.json();
      } catch (e) {
        result = {};
      }

      if (response.ok) {
        alert("✅ Form submitted successfully!");
        setForm({
          listing_level: "Level One",
          agency_name: "",
          email: "",
          mobile: "",
          declaration_consent: false,
          region: "",
          chapter: "",
        });
        setStatesList([]);
        setCitiesList([]);
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        // Handle duplicates and other errors as before
        if (
          result?.message?.toLowerCase()?.includes("email") &&
          result?.message?.toLowerCase()?.includes("duplicate")
        ) {
          alert("❌ This email already exists.");
        } else if (
          result?.message?.toLowerCase()?.includes("mobile") &&
          result?.message?.toLowerCase()?.includes("duplicate")
        ) {
          alert("❌ This mobile number already exists.");
        } else if (result?.error?.includes("Duplicate entry")) {
          if (result.error.includes("email")) {
            alert("❌ Email already registered.");
          } else if (result.error.includes("mobile")) {
            alert("❌ Mobile number already registered.");
          } else {
            alert("❌ Duplicate entry found.");
          }
        } else {
          alert(
            `❌ Submission failed: ${result?.message || response.statusText}`
          );
        }
      }
    } catch (error) {
      console.error("Submission Error:", error);
      alert("❌ Network error or server did not respond correctly.");
    }
  };

  return (
    <div className="page">
      <div className="container">
        {/* HEADER */}
        <div className="header">
          <img src={A1} alt="Logo" className="logo" />
          <div className="header-text">
            <h2>Travel Agents Association of India</h2>
            <p className="subtitle">Membership ID Card & Directory Application</p>
          </div>
        </div>

        {/* SECTION 1: AGENCY DETAILS */}
        <section className="card">
          <h4 className="section-title">Section 1: Agency Details (Mandatory)</h4>
          <div className="grid">
            <Field label="Name of Agency" name="agency_name" value={form.agency_name || ""} onChange={handleChange} required />
            <Select label="Category" name="category" value={form.category || ""} options={["Active", "Associate", "Allied"]} onChange={handleChange} />
            <Field label="Year of Joining (If Available)" name="year_of_joining" type="number" placeholder="Enter Year (e.g., 2026)" value={form.year_of_joining || ""} onChange={handleChange} />
            <Field label="Agency Membership ID (Optional)" name="membership_id" value={form.membership_id || ""} onChange={handleChange} />
            <div className="field">
              <label>Region</label>
              <select name="region" value={form.region || ""} onChange={handleChange}>
                <option value="">Select Region</option>
                {REGION_OPTIONS.map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
              </select>
            </div>

            <div className="field">
              <label>Chapter</label>
              <select name="chapter" value={form.chapter || ""} onChange={handleChange} >
                <option value="">Select Chapter</option>
                {CHAPTER_OPTIONS.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>
            <Field label="Address" name="address" value={form.address || ""} onChange={handleChange} />

            <div className="field">
              <label>Country</label>
              <select name="country" value={form.country || ""} onChange={handleChange}>
                <option value="">Select Country</option>
                {Country.getAllCountries().map((c) => (
                  <option key={c.isoCode} value={c.isoCode}>{c.name}</option>
                ))}
              </select>
            </div>

            <div className="field">
              <label>State</label>
              <select name="state" value={form.state || ""} onChange={handleChange} disabled={!statesList.length}>
                <option value="">Select State</option>
                {statesList.map((s) => (
                  <option key={s.isoCode} value={s.isoCode}>{s.name}</option>
                ))}
              </select>
            </div>

            <div className="field">
              <label>City</label>
              <select name="city" value={form.city || ""} onChange={handleChange} disabled={!citiesList.length}>
                <option value="">Select City</option>
                {citiesList.map((city) => (
                  <option key={city.name} value={city.name}>{city.name}</option>
                ))}
              </select>
            </div>

            <Field label="Pin Code" name="pin_code" value={form.pin_code || ""} onChange={handleChange} />
            <Field label="Official Email ID (For Official Purpose)" name="email" value={form.email || ""} onChange={handleChange} required />
            <Field label="Official Phone Number" name="telephone" value={form.telephone || ""} onChange={handleChange} />
            <Field label="Mobile Number" name="mobile" value={form.mobile || ""} onChange={handleChange} required />
            <Field label="Website Address" name="website" value={form.website || ""} onChange={handleChange} />
          </div>
        </section>

        {/* SECTION 2: ACCREDITED REPRESENTATIVES */}
        <section className="card">
          <h4 className="section-title">Section 2: Accredited Representatives (For ID Card)</h4>

          <h5>Primary Representative</h5>
          <div className="grid">
            <Field label="Full Name" name="acc_rep1_name" value={form.acc_rep1_name || ""} onChange={handleChange} />
            <Field label="Designation (Owner/CEO/etc.)" name="acc_rep1_designation" value={form.acc_rep1_designation || ""} onChange={handleChange} />
            <Field label="Mobile" name="acc_rep1_mobile" value={form.acc_rep1_mobile || ""} onChange={handleChange} />
            <Field label="Email" name="acc_rep1_email" value={form.acc_rep1_email || ""} onChange={handleChange} />
            <Field label="Date of Birth" name="acc_rep1_dob" type="date" value={form.acc_rep1_dob || ""} onChange={handleChange} />
            <Field label="Wedding Anniversary" name="acc_rep1_anniversary" type="date" value={form.acc_rep1_anniversary || ""} onChange={handleChange} />
            <Select label="Blood Group" name="acc_rep1_blood_group" value={form.acc_rep1_blood_group || ""} options={BLOOD_GROUPS1} onChange={handleChange} />
            <Field label="Upload Photograph (Passport Size) - Max 1MB" name="acc_rep1_photo" type="file" accept="image/*" onChange={handleChange} />
          </div>

          <hr className="divider" />

          <h5>Secondary Representative (Optional)</h5>
          <div className="grid">
            <Field label="Full Name" name="acc_rep2_name" value={form.acc_rep2_name || ""} onChange={handleChange} />
            <Field label="Designation" name="acc_rep2_designation" value={form.acc_rep2_designation || ""} onChange={handleChange} />
            <Field label="Mobile" name="acc_rep2_mobile" value={form.acc_rep2_mobile || ""} onChange={handleChange} />
            <Field label="Email" name="acc_rep2_email" value={form.acc_rep2_email || ""} onChange={handleChange} />
            <Field label="Date of Birth" name="acc_rep2_dob" type="date" value={form.acc_rep2_dob || ""} onChange={handleChange} />
            <Field label="Wedding Anniversary" name="acc_rep2_anniversary" type="date" value={form.acc_rep2_anniversary || ""} onChange={handleChange} />
            <Select label="Blood Group" name="acc_rep2_blood_group" value={form.acc_rep2_blood_group || ""} options={BLOOD_GROUPS2} onChange={handleChange} />
            <Field label="Upload Photograph (Passport Size) - Max 1MB" name="acc_rep2_photo" type="file" accept="image/*" onChange={handleChange} />

          </div>
        </section>

        {/* SECTION 3: BUSINESS PROFILE */}
        <section className="card">
          <h4 className="section-title">Section 3: Business Profile</h4>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ fontSize: "14px", fontWeight: "bold", display: "block", marginBottom: "2px" }}>
              Key Areas of Activity:
            </label>
            <span style={{ fontSize: "12px", color: "#666", fontStyle: "italic" }}>
              (Tick appropriate vertical/s)
            </span>
          </div>

          <div className="checkbox-grid">
            <Checkbox label="Air Ticketing" name="air_ticketing" checked={form.air_ticketing || false} onChange={handleChange} />
            <Checkbox label="Tourism (Outbound)" name="tourism_outbound" checked={form.tourism_outbound || false} onChange={handleChange} />
            <Checkbox label="Tourism (Inbound & Domestic)" name="tourism_inbound_domestic" checked={form.tourism_inbound_domestic || false} onChange={handleChange} />
            <Checkbox label="MICE & Special Events" name="mice_events" checked={form.mice_events || false} onChange={handleChange} />
            <Checkbox label="DMC" name="dmc" checked={form.dmc || false} onChange={handleChange} />
            <Checkbox label="Online Selling Portals (OTA)" name="online_portal" checked={form.online_portal || false} onChange={handleChange} />
            <Checkbox label="Technology" name="technology" checked={form.technology || false} onChange={handleChange} />
            <Checkbox label="Education" name="education" checked={form.education || false} onChange={handleChange} />
            <Checkbox label="Hotels" name="hotels" checked={form.hotels || false} onChange={handleChange} />
            <Checkbox label="Wedding Planners" name="wedding_planners" checked={form.wedding_planners || false} onChange={handleChange} />
            <Checkbox label="Others" name="others_checkbox" checked={form.others_checkbox || false} onChange={handleChange} />
          </div>

          {/* Show text field if 'Others' is selected */}
          {form.others_checkbox && (
            <div className="field" style={{ marginTop: "15px" }}>
              <input
                type="text"
                name="other_activity_details"
                placeholder="Please specify other activities..."
                value={form.other_activity_details || ""}
                onChange={handleChange}
              />
            </div>
          )}
        </section>

        {/* SECTION 4 & 5: DIRECTORY LISTING & CONTENT */}
        <section className="card">
          <h4 className="section-title">Section 4 & 5: Directory Listing Options</h4>

          {/* Original Text maintained exactly */}
          <div style={{ fontSize: "14px", color: "#333", marginBottom: "20px", lineHeight: "1.6" }}>
            <strong>* Size of Directory : Similar to A4 size</strong> <br />
          </div>

          <div className="field">
            <label style={{ fontWeight: "bold", marginBottom: "10px", display: "block" }}>Select Listing Level</label>
            {[
              { value: "Level One", label: "Level ONE - Complimentary Listing (One Small Box with Agency Name & Contact Details)" },
              { value: "Level Two", label: "Level TWO - ₹2,000 (Additional Box for Profile (2x Level One) with LOGO)" },
              { value: "Level Three", label: "Level Three – ₹5,000 (Complimentary Listing included in Strip Advertising (Full Width of the Page))" }
            ].map((opt) => (
              <label key={opt.value} className="radio-label" style={{ marginBottom: "12px", display: "block", cursor: "pointer" }}>
                <input
                  type="radio"
                  name="listing_level"
                  value={opt.value}
                  checked={form.listing_level === opt.value}
                  onChange={handleChange}
                />
                <span style={{ marginLeft: "8px", fontWeight: form.listing_level === opt.value ? "bold" : "normal" }}>
                  {opt.label}
                </span>
              </label>
            ))}
          </div>

          <span style={{ fontSize: "12px", color: "#666" }}>
            (Other advertising options available - Write to <a href="mailto:directory@taai.in">directory@taai.in</a>)
          </span>

          {/* IMPORTANT NOTICE */}
          <p style={{ fontSize: "14px", color: "#d32f2f", fontWeight: "bold", marginTop: "10px" }}>
            Once you confirm Level 2 or Level 3, you will get the separate format for you to fill in
          </p>

          {/* Separate format fields for Level 2 or Level 3 */}
          {(form.listing_level === "Level Two" || form.listing_level === "Level Three") && (
            <div className="grid animate-fade-in" style={{ marginTop: "20px", padding: "20px", background: "#f0f7ff", borderRadius: "8px", border: "1px dashed #2563eb" }}>


              <Field
                label="Upload Company Logo (Level Two & Level Three) - Max 10MB (JPG, PNG)"
                name="company_logo"
                type="file"
                accept="image/*"
                onChange={handleChange}
              />

              {/* {form.listing_level === "Level Three" && (
                <Field
                  label="Upload Strip Ad Artwork (Full Width) - (Level Three) - Max 10MB (JPG, PNG)"
                  name="ad_artwork"
                  type="file"
                  accept="image/*"
                  onChange={handleChange}
                />
              )} */}
              {form.listing_level === "Level Three" && (
                <div style={{ padding: "10px", background: "#f5f5f5", borderRadius: "6px" }}>
                  Level Three – ₹5,000 (Includes complimentary listing + a full-width strip advertisement. Detailed artwork specifications and submission guidelines will be shared separately via email after 11th May 2026.)
                </div>
              )}
            </div>
          )}
        </section>

        {/* SECTION 6 & 7: CONSENT & DECLARATION */}
        <section className="card">
          <h4 className="section-title">Section 6 & 7: Consent & Declaration</h4>
          <div className="consent-box">
            <Checkbox
              label="I consent to use submitted details for the Membership Directory, Digital Profile/QR Code, and ID Card generation."
              name="digital_profile_consent"
              checked={form.digital_profile_consent || false}
              onChange={handleChange}
            />
            <br />
            <Checkbox
              label="I confirm that the above information is accurate and approved for publication and official use by TAAI."
              name="declaration_consent"
              checked={form.declaration_consent || false}
              onChange={handleChange}
              required
            />
          </div>
        </section>

        <button className="submit" onClick={handleSubmit}>Submit Application</button>
      </div>

      <style>{`
        .page { background: #f4f6f9; min-height: 100vh; padding: 30px 10px; }
        .container { max-width: 1000px; margin: auto; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
        .header { display: flex; align-items: center; gap: 20px; margin-bottom: 25px; background: white; padding: 20px; border-radius: 10px; }
        .logo { height: 70px; }
        .header-text h2 { margin: 0; color: #1e3a8a; }
        .section-title { color: #1e3a8a; border-left: 4px solid #2563eb; padding-left: 10px; margin-bottom: 20px; text-transform: uppercase; font-size: 14px; }
        .card { background: white; padding: 25px; border-radius: 10px; margin-bottom: 20px; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
        .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 15px; }
        .field label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 5px; color: #374151; }
        .field input, .field select, .field textarea { width: 100%; padding: 10px; border-radius: 6px; border: 1px solid #d1d5db; box-sizing: border-box; }
        .full-width { grid-column: 1 / -1; }
        .checkbox-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 10px; }
        .radio-label { display: block; margin-bottom: 8px; font-size: 14px; cursor: pointer; }
        .radio-label input { width: auto; margin-right: 10px; }
        .divider { border: 0; border-top: 1px solid #eee; margin: 25px 0; }
        .consent-box { background: #eff6ff; padding: 15px; border-radius: 8px; }
        .submit { width: 100%; padding: 16px; background: #2563eb; color: white; border: none; border-radius: 8px; font-size: 16px; font-weight: bold; cursor: pointer; transition: background 0.2s; }
        .submit:hover { background: #1d4ed8; }
        @media (max-width: 640px) { .header { flex-direction: column; text-align: center; } }
      `}</style>
    </div>
  );
};

/* REUSABLE COMPONENTS */
const Field = ({ label, name, value, onChange, type = "text", placeholder, required, accept }) => (
  <div className="field">
    <label>{label} {required && <span style={{ color: "red" }}>*</span>}</label>
    <input
      type={type}
      name={name}
      accept={accept} // Added this line
      placeholder={placeholder || `Enter ${label}`}
      onChange={onChange}
      value={type === "file" ? undefined : value}
    />
  </div>
);

const Select = ({ label, name, options, value, onChange }) => (
  <div className="field">
    <label>{label}</label>
    <select name={name} value={value} onChange={onChange}>
      <option value="">Select {label}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </div>
);

const Checkbox = ({ label, name, checked, onChange, required }) => (
  <label style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "14px", cursor: "pointer" }}>
    <input type="checkbox" name={name} checked={checked} onChange={onChange} style={{ width: "18px", height: "18px" }} />
    <span>{label} {required && <span style={{ color: "red" }}>*</span>}</span>
  </label>
);

export default Form;